import { useContext } from 'react'
import { Change } from './changesTypes'
import { ChangeBlock, ChangesContext } from './ChangesAction'
import ForestChangeBlock, { ForestParentChanges } from './modules/forest/ForestChangeBlock'

const GenericChangeBlock = ({ change }: { change: Change }) => {
    const path = useContext(ChangesContext).currentModule?.path
    switch (path) {
        case "forest-managements":
            if (!change) return null
            return <ForestChangeBlock change={change as ForestParentChanges} />
        default:
            return <ChangeBlock change={change} />
    }
}

export default GenericChangeBlock